// src/utils/logout.ts

export const logout = async () => {
  // Call backend to clear httpOnly cookies
  try {
    await fetch(`${import.meta.env.VITE_API_URL || ''}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // ignore network errors
  }
  localStorage.removeItem('user');
  location.href = '/auth/login';
};
